var map = {
	"./coins-1260.png": 3253,
	"./coins-1260@2x.png": 7967,
	"./coins-1416.png": 5632,
	"./coins-1416@2x.png": 9736,
	"./coins-1560.png": 3558,
	"./coins-1560@2x.png": 5214,
	"./coins-385.png": 1430,
	"./coins-385@2x.png": 6718,
	"./coins-585.png": 7200,
	"./coins-585@2x.png": 3048,
	"./coins-885.png": 2301,
	"./coins-885@2x.png": 9415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8618;